<template>
    <b-row>
        <b-col sm="12">
            <b-card>
                <b-row class="pt-sm-1">
                    <b-col sm="1">
                        <span class="card-title wise-card-title">검색 조건</span>
                    </b-col>
                    <b-col sm="1"><strong>검색어</strong></b-col>
                    <b-col sm="8">
                        <b-form-input v-model="queryParams.keyword" placeholder=""
                            v-on:keyup="$event.keyCode === 13 ? findExtSite() : ''"></b-form-input>
                    </b-col>
                    <b-col sm="2" style="text-align: center;">
                        <b-button variant="primary" style="width: 100%;" v-on:click="findExtSite()">검색</b-button>
                    </b-col>
                </b-row>
                <b-row class="pt-sm-2">
                    <b-col sm="1"></b-col>
                    <b-col sm="1"><strong>수집여부</strong></b-col>
                    <b-col sm="4" style="display: inline-flex;">
                        <b-form-checkbox v-model="isCheckStatus" style="padding-right: 15px;" @change="allCheckStatus">전체</b-form-checkbox>
                        <b-form-checkbox-group v-model="queryParams.status" @click.native="isCheckStatus = false">
                            <b-form-checkbox value="Y">노출</b-form-checkbox>
                            <b-form-checkbox value="N">비노출</b-form-checkbox>
                        </b-form-checkbox-group>
                    </b-col>
                </b-row>

            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import "vue2-datepicker/index.css";

import { EventBus } from "../../../event-bus";

export default {
    name: "extReportSiteSearch",
    props: {
        fullDate: {
            type: Array,
        },
        queryParams: {
            keyword: {
                type: String,
            },
            status: {
                type: Array,
            }
        },
    },
    components: {
    },
    mounted() {
        this.findSiteList();
    },
    data() {
        return {
            datepickerLang: {
                yearFormat: "YYYY년",
                monthFormat: "M월",
                days:["일","월","화","수","목","금","토"]
            },
            fullDateTmp: [],
            siteList: [],       // 사이트 목록
            interestList: [],   // 관심카테고리 목록
            isCheckStatus: false,
            isCheckSite: false,
            isCheckCategory: false,
            isCheckHastags: false,
            isOpen: false,
        }
    },
    methods: {
        // 외부리포트 사이트 검색
        findExtSite() {
            // console.log(this.queryParams, this.fullDate);
            EventBus.$emit('callFindExtSite');
        },
        // 사이트 목록
        findSiteList() {
            // /api/select/extSiteList
            var token = sessionStorage.getItem("myToken");
            this.$http.get('/api/select/extSiteList?access_token='+token)
            .then((result) => {
                    const { data } = result;
                    this.siteList = data;
            })
        },

        allCheckStatus(){
            this.isCheckStatus = !this.isCheckStatus;
            if(this.isCheckStatus) {
                this.queryParams.status = ["Y", "N"];
            }else{
                this.queryParams.status = [];
            }
        },

    },
}
</script>




// WEBPACK FOOTER //
// src/views/contents/extSite/component/ExtSiteSearch.vue